export const duckName = 'welcome'
